import { render, staticRenderFns } from "./buyContractMag.vue?vue&type=template&id=aa7e1a0c&scoped=true&"
import script from "./buyContractMag.vue?vue&type=script&lang=js&"
export * from "./buyContractMag.vue?vue&type=script&lang=js&"
import style0 from "./buyContractMag.vue?vue&type=style&index=0&id=aa7e1a0c&scoped=true&lang=css&"
import style1 from "./buyContractMag.vue?vue&type=style&index=1&id=aa7e1a0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7e1a0c",
  null
  
)

export default component.exports